import Swiper from 'swiper/bundle';
import { Autoplay, Navigation, Pagination, Lazy } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

document.addEventListener("DOMContentLoaded", function () {


    new Swiper(".swiper-hero", {
        modules: [Autoplay],
        centeredSlides: true,
        grabCursor: true,
        spaceBetween: 0,
        autoHeight: true,
        slidesPerView: 'auto',
        loop: true,
        autoplay: {
            delay: 1,
            disableOnInteraction: false,
        },
        speed: 20000,
        breakpoints: {
            768: {
                slidesPerView: 4,
            },
        },
    });

    const roomSwipers = document.querySelectorAll('.swiper-room');

    roomSwipers.forEach((swiperEl) => {
        new Swiper(swiperEl, {
            modules: [Pagination, Navigation],
            slidesPerView: 1,
            spaceBetween: 0,
            loop: false,
            pagination: {
                el: swiperEl.querySelector('.swiper-pagination'),
                clickable: true,
                bulletClass: 'swiper-pagination-bullet',
                bulletActiveClass: 'swiper-pagination-bullet-active',
            },
            navigation: {
                nextEl: swiperEl.querySelector('.swiper-button-next'),
                prevEl: swiperEl.querySelector('.swiper-button-prev'),
            },
            on: {
                slideChange: function () {
                    // Preload next images
                    this.lazy.load();
                }
            }
        });
    });

    const gallerySwipers = document.querySelectorAll('.swiper-gallery');

    gallerySwipers.forEach((swiperEl) => {
        new Swiper(swiperEl, {
            modules: [Pagination, Navigation],
            slidesPerView: 1,
            spaceBetween: 16,
            loop: true,
            pagination: {
                el: swiperEl.querySelector('.swiper-pagination'),
                clickable: true,
                bulletClass: 'swiper-pagination-bullet',
                bulletActiveClass: 'swiper-pagination-bullet-active',
            },
            navigation: {
                nextEl: swiperEl.querySelector('.swiper-button-next'),
                prevEl: swiperEl.querySelector('.swiper-button-prev'),
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetween: 24,
                },
                1200: {
                    slidesPerView: 3,
                    spaceBetween: 24,
                }
            }
        });
    });

    const roomsSwipers = document.querySelectorAll('.swiper-rooms');

    roomsSwipers.forEach((swiperEl) => {
        new Swiper(swiperEl, {
            modules: [Pagination, Navigation],
            slidesPerView: 1,
            spaceBetween: 16,
            loop: true,
            pagination: {
                el: swiperEl.querySelector('.swiper-pagination'),
                clickable: true,
                bulletClass: 'swiper-pagination-bullet',
                bulletActiveClass: 'swiper-pagination-bullet-active',
            },
            navigation: {
                nextEl: swiperEl.querySelector('.swiper-button-next'),
                prevEl: swiperEl.querySelector('.swiper-button-prev'),
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetween: 24,
                },
                1200: {
                    slidesPerView: 3,
                    spaceBetween: 24,
                }
            }
        });
    });

    const whySwipers = document.querySelectorAll('.swiper-why');

    whySwipers.forEach((swiperEl) => {
        new Swiper(swiperEl, {
            modules: [Pagination, Navigation],
            slidesPerView: 1.08,
            spaceBetween: 14,
            loop: false,
            pagination: {
                el: swiperEl.querySelector('.swiper-pagination'),
                clickable: true,
                bulletClass: 'swiper-pagination-bullet',
                bulletActiveClass: 'swiper-pagination-bullet-active',
            },
            navigation: {
                nextEl: swiperEl.querySelector('.swiper-button-next'),
                prevEl: swiperEl.querySelector('.swiper-button-prev'),
            },
            breakpoints: {
                768: {
                    slidesPerView: 1.45,
                    spaceBetween: 16,
                },
                1200: {
                    slidesPerView: 2,
                    spaceBetween: 18,
                }
            }
        });
    });

    const initCreateWorkSwiper = (swiperEl) => {
        if (swiperEl.swiper) return swiperEl.swiper;

        return new Swiper(swiperEl, {
            modules: [Pagination, Navigation],
            slidesPerView: 1,
            spaceBetween: 16,
            loop: true,
            pagination: {
                el: swiperEl.querySelector('.swiper-pagination'),
                clickable: true,
                bulletClass: 'swiper-pagination-bullet',
                bulletActiveClass: 'swiper-pagination-bullet-active',
            },
            navigation: {
                nextEl: swiperEl.querySelector('.swiper-button-next'),
                prevEl: swiperEl.querySelector('.swiper-button-prev'),
            },
            breakpoints: {
                768: {
                    slidesPerView: 2.2,
                    spaceBetween: 20,
                },
                1200: {
                    slidesPerView: 3.2,
                    spaceBetween: 24,
                }
            }
        });
    };

    const createWorkSwipers = document.querySelectorAll('.swiper-create-work');

    createWorkSwipers.forEach((swiperEl) => {
        const revealEl = swiperEl.closest('[data-create-work-reveal]');
        const toggleButton = revealEl?.id ? document.querySelector(`[data-create-work-toggle][aria-controls="${revealEl.id}"]`) : null;
        const openLabel = toggleButton?.querySelector('[data-create-work-label-open]');
        const closeLabel = toggleButton?.querySelector('[data-create-work-label-close]');

        if (revealEl?.classList.contains('collapse') && toggleButton) {
            revealEl.addEventListener('shown.bs.collapse', () => {
                openLabel?.classList.add('d-none');
                closeLabel?.classList.remove('d-none');

                const swiper = initCreateWorkSwiper(swiperEl);

                window.requestAnimationFrame(() => {
                    swiper.update();

                    if (window.AOS?.refreshHard) {
                        window.AOS.refreshHard();
                    } else if (window.AOS?.refresh) {
                        window.AOS.refresh();
                    }
                });
            });

            revealEl.addEventListener('hidden.bs.collapse', () => {
                openLabel?.classList.remove('d-none');
                closeLabel?.classList.add('d-none');

                if (window.AOS?.refreshHard) {
                    window.AOS.refreshHard();
                } else if (window.AOS?.refresh) {
                    window.AOS.refresh();
                }
            });

            return;
        }

        initCreateWorkSwiper(swiperEl);
    });

    const roomDetailSwipers = document.querySelectorAll('.swiper-room-detail');

    roomDetailSwipers.forEach((swiperEl) => {
        new Swiper(swiperEl, {
            modules: [Pagination, Navigation],
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            pagination: {
                el: swiperEl.querySelector('.swiper-pagination'),
                clickable: true,
                bulletClass: 'swiper-pagination-bullet',
                bulletActiveClass: 'swiper-pagination-bullet-active',
            },
            navigation: {
                nextEl: swiperEl.querySelector('.swiper-button-next'),
                prevEl: swiperEl.querySelector('.swiper-button-prev'),
            }
        });
    });

});
